/**
 * Quand proposer d'installer l'application sur le téléphone. Règles pures, testées à part (install.ts les applique).
 * - `prompt` : le navigateur sait installer en un toucher (Chrome, Samsung Internet sur Android) ;
 * - `ios` : iPhone ou iPad, l'installation se fait à la main (Partager, puis « Sur l'écran d'accueil ») ;
 * - `manual` : autre navigateur, on explique où chercher dans le menu.
 */
export type InstallMode = "prompt" | "ios" | "manual";

/** « Plus tard » masque la carte pendant 7 jours. */
export const SNOOZE_MS = 7 * 24 * 3600_000;

export function installMode(canPrompt: boolean, isIos: boolean): InstallMode {
  if (canPrompt) return "prompt";
  return isIos ? "ios" : "manual";
}

export interface CardState {
  /** Déjà ouverte comme une application installée. */
  standalone: boolean;
  /** Arrivée depuis la page d'accueil avec ?installer=1. */
  requested: boolean;
  /** Date du dernier « Plus tard », en millisecondes. */
  snoozedAt: number | null;
  mode: InstallMode;
  now: number;
}

export function shouldShowCard(s: CardState): boolean {
  if (s.standalone) return false;
  // Demandée explicitement : affichée tout de suite, même après un « Plus tard ».
  if (s.requested) return true;
  if (s.snoozedAt != null && s.now - s.snoozedAt < SNOOZE_MS) return false;
  // Sans demande, seulement là où l'installation est simple : jamais d'explication de menu sur ordinateur.
  return s.mode !== "manual";
}

/** iPhone, iPod, ou iPad récent (qui se présente comme un Mac avec écran tactile). */
export function isIosDevice(userAgent: string, platform: string, maxTouchPoints: number): boolean {
  return /iPad|iPhone|iPod/.test(userAgent) || (platform === "MacIntel" && maxTouchPoints > 1);
}
